import React from "react";
import Select from "react-select";
import SelectPagginationForInvoice from "../Const/SelectPagginationForInvoice";

const ProductDetailsVariant = ({
  mainState,
  setMainState,
  mainInnerState,
  setMainInnerState,
  selectedVariants,
  setSelectedVariants,
  handleMultiInputChange,
  inputProduct,
  ProductsList,
  defaultValue,
  setProductsList,
  inputQuery,
  membershipInfo,
  isLoading,
  pS,
  setPs,
  voucher,
  getBasePlusVariant,
  getSubTotal,
  getDeliveryCharge,
  getGrandTotal,
  getDueAmount,
  Discount,
  setDiscount,
  invoice_discount_type,
  invoice_delivery_charge,
  customCharge,
  setCustomCharge,
  InvoiceAllData,
  handleInputs,
  SetInvoiceAllData,
  success,
  redeem,
  showToast,
}) => {
  const VariantThead = () => {
    return (
      <>
        {Object.keys(mainInnerState).length > 0 && (
          <thead style={{ border: "1.5px solid #E0E0E0" }}>
            <tr className="px-3" style={{ height: "45px" }}>
              <th
                className="minWidthForInvoiceCreateTable ps-4"
                style={{ width: "349px", textAlign: "start" }}
              >
                Variant
              </th>
              <th
                className="minWidthForInvoiceCreateTable  py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                Price
              </th>

              <th
                className="minWidthForInvoiceCreateTable  py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                In Stock
              </th>
              <th
                className="minWidthForInvoiceCreateTable py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                Quantity
              </th>

              <th
                className="minWidthForInvoiceCreateTable py-3"
                style={{ width: "150px", textAlign: "center" }}
              >
                Total
              </th>
            </tr>
          </thead>
        )}
      </>
    );
  };

  const handleInnerVariant = (currentName, value) => {
    setMainInnerState({
      ...mainInnerState,
      [currentName]: value,
    });
  };

  return (
    <div
      className="invoice-b my-4 bg-white cat-child"
      style={{ borderTop: "0.5px solid #E0E0E0" }}
    >
      <h4 className=" my-2 mb-4 padding-main-head">Product Details</h4>
      <div className="border-p"></div>
      <div className="padding-main">
        <div className="main-select">
          <SelectPagginationForInvoice
            handleMultiInputChange={handleMultiInputChange}
            inputProduct={inputProduct}
            ProductsList={ProductsList}
            defaultValue={defaultValue}
            setProductsList={setProductsList}
            inputQuery={inputQuery}
            mobile={membershipInfo ? membershipInfo?.mobile : ""}
          />
        </div>

        <div className="mt-3">
          <div
            className="rounded"
            style={{
              background: "#FAFAFA",
              display: "block",
              overflowX: "hidden",
              width: "100%",
            }}
          >
            <div style={{ padding: "10px" }}>
              {/* Table Header */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                  gap: "10px",
                  padding: "10px",
                  background: "rgba(245, 245, 245, 0.36)",
                  borderBottom: "1px solid #E0E0E0",
                  fontWeight: "bold",
                }}
              >
                <div>Product</div>
                <div style={{ textAlign: "center" }}>Price</div>
                <div style={{ textAlign: "center" }}>Stock</div>
                <div style={{ textAlign: "center" }}>Quantity</div>
                <div style={{ textAlign: "center" }}>Total</div>
              </div>

              {/* Variant Rows */}
              {Object.keys(mainState).map((curr, index) => {
                const item = mainState[curr];
                const variant =
                  item.variant && item.variant.length > 0
                    ? item.variant[0]
                    : null;

                if (!variant) return null;

                const variantName = item.variantName || variant.name;
                const productName = item.productName || curr;
                const variantSku = item.variantSku || variant.id;
                const variantObjKey =
                  Object.keys(item.variantObj || {})[0] || variantName;
                const variantData = item.variantObj?.[variantObjKey] || variant;

                return (
                  <div
                    key={index}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                      gap: "10px",
                      padding: "15px 10px",
                      borderBottom: "1px solid #E0E0E0",
                      alignItems: "center",
                    }}
                  >
                    {/* Product Column */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={item.thumb || item.image}
                        alt={productName}
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          border: "0.2px solid #bcb0b0",
                          borderRadius: "4px",
                        }}
                      />
                      <div>
                        <div style={{ fontWeight: "500", marginBottom: "4px" }}>
                          {productName}
                        </div>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                          {variantName}
                        </div>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                          SKU: {variantSku}
                        </div>
                        {item.discount > 0 && (
                          <div style={{ fontSize: "12px", color: "#666" }}>
                            Discount: {item.discount}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Price Column */}
                    <div style={{ textAlign: "center" }}>
                      <input
                        value={
                          variantData.calculated_price !== undefined
                            ? variantData.calculated_price
                            : variantData.price || 0
                        }
                        className="invoiceCreateSmallInputs"
                        placeholder="00.00"
                        type="text"
                        readOnly
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    </div>

                    {/* Stock Column */}
                    <div style={{ textAlign: "center" }}>
                      <input
                        value={Number(variantData.stock || variant.stock)}
                        className="invoiceCreateSmallInputs"
                        placeholder="00.00"
                        type="text"
                        readOnly
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    </div>

                    {/* Quantity Column */}
                    <div style={{ textAlign: "center" }}>
                      <input
                        name="in_quantity"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          if (e.target.value < 0) {
                            setPs(0);
                          } else {
                            setPs(e.target.value);
                          }

                          setMainState((prevInputs) => {
                            const copiedObjects = Object.assign({}, prevInputs);
                            const variantObjKey =
                              Object.keys(
                                copiedObjects[curr]?.variantObj || {}
                              )[0] || variantName;

                            if (
                              !copiedObjects[curr] ||
                              !copiedObjects[curr].variantObj ||
                              !copiedObjects[curr].variantObj[variantObjKey]
                            ) {
                              return prevInputs;
                            }

                            const quantityValue = parseInt(e.target.value) || 0;

                            if (quantityValue < 0) {
                              copiedObjects[curr].variantObj[
                                variantObjKey
                              ].quantity = 0;
                            } else if (
                              quantityValue >
                              (variantData.stock || variant.stock)
                            ) {
                              if (showToast) {
                                showToast(
                                  "error",
                                  `Max Stock : ${
                                    variantData.stock || variant.stock
                                  }`
                                );
                              }
                              copiedObjects[curr].variantObj[
                                variantObjKey
                              ].quantity = variantData.stock || variant.stock;
                            } else {
                              copiedObjects[curr].variantObj[
                                variantObjKey
                              ].quantity = quantityValue;
                            }

                            // Since we're using calculated_price, use it directly without adding base price
                            const variantPrice = parseInt(
                              copiedObjects[curr].variantObj[variantObjKey][
                                "price"
                              ] || 0
                            );

                            copiedObjects[curr].variantObj[variantObjKey][
                              "total"
                            ] =
                              (copiedObjects[curr].variantObj[variantObjKey][
                                "quantity"
                              ] || 0) * variantPrice;

                            return copiedObjects;
                          });
                        }}
                        className="invoiceCreateSmallInputs"
                        placeholder="00.00"
                        type="number"
                        value={
                          variantData.quantity === undefined ||
                          variantData.quantity === "-1" ||
                          variantData.quantity === -1
                            ? 0
                            : variantData.quantity
                        }
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    </div>

                    {/* Total Column */}
                    <div style={{ textAlign: "center" }}>
                      <input
                        value={
                          variantData &&
                          variantData.total !== undefined &&
                          !isNaN(variantData.total)
                            ? variantData.total
                            : 0
                        }
                        className="invoiceCreateSmallInputs"
                        placeholder="00.00"
                        type="text"
                        readOnly
                        style={{ width: "100%", textAlign: "center" }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="d-flex flex-column flex-md-row mt-4 justify-content-between mx-4">
              <div>
                <h6>Total Variants : {Object?.keys(mainState)?.length}</h6>
              </div>
              <div>
                <div
                  className="d-flex justify-content-between "
                  style={{
                    color: "#212121",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <p>Sub Total :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="text"
                      value={isNaN(getSubTotal()) ? 0 : getSubTotal()}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between cl d-none">
                  <p>Delivery Charge : </p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="number"
                      onChange={(e) => setCustomCharge(e.target.value)}
                      value={getDeliveryCharge()}
                      style={{ border: "1px solid gray" }}
                    />
                  </p>
                </div>
                <div className="d-flex justify-content-between pl pt-2">
                  <p>
                    Discount{" "}
                    {invoice_discount_type === "0" ||
                    invoice_discount_type === 0
                      ? ""
                      : "%"}{" "}
                    :
                  </p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      name="invoice_paid"
                      type="text"
                      value={Discount}
                      onChange={(e) => setDiscount(e.target.value)}
                      disabled={Object.values(mainState).some(
                        (item) => item.discount && parseInt(item.discount) > 0
                      )}
                    />
                  </p>
                </div>
                {success && (
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      color: "#212121",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    <p>Redeem Discount :</p>
                    <p className="ms-3 ">
                      <input
                        className="ms-3 invoiceInpCss"
                        type="text"
                        value={redeem}
                      />
                    </p>
                  </div>
                )}

                <div
                  className="d-flex justify-content-between"
                  style={{
                    color: "#212121",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <p>Total amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="text"
                      value={isNaN(getGrandTotal()) ? 0 : getGrandTotal()}
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between pl pt-2">
                  <p>Paid amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      name="invoice_paid"
                      type="text"
                      value={isNaN(getGrandTotal()) ? 0 : getGrandTotal()}
                      disabled
                    />
                  </p>
                </div>

                <div className="d-flex justify-content-between cl">
                  <p>Due amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss"
                      type="text"
                      name="invoice_due"
                      value={isNaN(getDueAmount()) ? 0 : getDueAmount()}
                    />
                  </p>{" "}
                </div>
                <div className="d-flex justify-content-between cl">
                  <p>Recieved amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      type="number"
                      name="recived_amount"
                      value={InvoiceAllData["recived_amount"]}
                      onChange={(e) => handleInputs(e, SetInvoiceAllData)}
                    />
                  </p>{" "}
                </div>
                <div className="d-flex justify-content-between cl">
                  <p>Change Amount :</p>
                  <p className="ms-3 ">
                    <input
                      className="ms-3 invoiceInpCss paid_input_css"
                      type="number"
                      name="invoice_examount"
                      value={
                        InvoiceAllData["recived_amount"] > getGrandTotal()
                          ? Math.abs(
                              isNaN(getGrandTotal())
                                ? 0
                                : getGrandTotal() -
                                    InvoiceAllData["recived_amount"]
                            )
                          : 0
                      }
                    />
                  </p>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsVariant;
